module.exports = __webpack_public_path__ + "img/3riffix.cb4cc411.jpg";